import moment from 'moment';
import { ScoreTierEntity } from 'pages/LenderWaterfall/ScorecardBuilder/types';
import { FinanceProgramFormSteps, Structures, MarkupMethods } from '../types';
import { FinanceProgramForm } from '../schema';
import {
  FinanceProgramType,
  FinanceProgramRateType,
  PaymentPeriodTiming,
  SubsidyCapType,
} from '@trnsact/trnsact-shared-types';

export function getFinanceProgramInitialFormValues(scoreTiers?: ScoreTierEntity[]): FinanceProgramForm {
  return {
    step: FinanceProgramFormSteps.First,
    program: {
      id: null,
      first: {
        details: {
          name: '',
          displayName: '',
          guidelines: '',
          linkToLenderCreditApp: false,
          lenders: [],
          dealers: [],
          notes: '',
        },
        criteria: {
          criteria: null,
          conditions: [],
        },
        insuranceCoverage: {
          coverageRequirements: '',
          certificateRequirements: '',
          otherInstructions: '',
        },
        submissionSettings: {
          excludedDocuments: [],
          autoSubmitUserProfileId: '',
        },
      },
      second: {
        fee: [],
        rate: 0,
        terms: [],
        residual: 0,
        customerRate: 0,
        dealerMarkup: 0,
        specifyRates: [],
        daysToFirstPayment: '30',
        advancePayment: '0',
        isSpecifyRate: false,
        isValidityDates: false,
        isSubsidized: false,
        isTiersEnabled: !!scoreTiers?.length,
        structure: Structures.None,
        minimumRequiredDownPayment: 0,
        programType: FinanceProgramType.Loan,
        rateType: FinanceProgramRateType.InterestRate,
        method: MarkupMethods.CustomerRate,
        endDate: moment().toDate(),
        startDate: moment().toDate(),
        paymentCalculationMethod: PaymentPeriodTiming.BeginningOfPeriod,
        configureSubsidyCap: false,
        specifyLenderMarketRates: [],
        subsidyCapConfiguration: {
          subsidyCapType: SubsidyCapType.NetInvoicePercentage,
          lenderMarketRates: [],
          lenderName: '',
          maxSubsidyAmount: 0,
          netInvoicePercentage: 0,
        },
        tiers: null,
      },
    },
  };
}
